import { render } from "./WorkAreaDetailsPageEmployees.vue?vue&type=template&id=2c721b46"
import script from "./WorkAreaDetailsPageEmployees.vue?vue&type=script&lang=ts"
export * from "./WorkAreaDetailsPageEmployees.vue?vue&type=script&lang=ts"
script.render = render

export default script